import { MatxLoadable } from "matx";

const AppMap = MatxLoadable({
  loader: () => import("./AppMap"),
});

const mapRoutes = [
  {
    path: "/map",
    component: AppMap,
    permission: ["manager", "account_holder", "customer_service"],
  },
];

export default mapRoutes;
